import React from 'react';



const InstagramInput = ({ value, onChange, onSubmit, disabled }) => {
  const handleSubmit = (e) => {
    e?.preventDefault();
    if (value?.trim() && onSubmit) {
      onSubmit(value);
    }
  };

  return (
    <div className="mt-6 md:mt-8 lg:mt-10">
      <form onSubmit={handleSubmit} className="space-y-4">
      </form>
    </div>
  );
};

export default InstagramInput;